// Hideo - the classes of a filter or tag pill (a chip): the shape and the chosen / not chosen colours are shared, the
// spacing (layout) is the caller's. look 'tag': bordered (tag bars and pickers, plan filters); 'soft': bordered only when
// not chosen (Saved videos, Scripts); 'field': on the darker background of a form (Settings). Class names are whole, as
// Tailwind needs.
type ChipLook = 'tag' | 'soft' | 'field'

const LOOKS: Record<ChipLook, [on: string, off: string]> = {
  tag: ['border bg-brand text-white border-brand', 'border bg-darkcard text-gray-300 border-gray-800 hover:border-brand/50'],
  soft: ['bg-brand text-white', 'bg-darkcard border border-gray-800 text-gray-400 hover:text-gray-100'],
  field: ['border bg-brand text-white border-brand', 'border bg-darkinput text-gray-300 border-gray-800 hover:border-brand/50']
}

/** Classes of a pill: the shape, the spacing, the colours of its state */
export const chipCls = (on: boolean, look: ChipLook = 'tag', layout = 'inline-flex items-center px-3.5 py-1.5'): string[] =>
  ['rounded-full text-xs font-bold transition', layout, LOOKS[look][on ? 0 : 1]]
